exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#loginContainer{background-color:#fff;max-width:450px;margin:5px;padding:15px 10px 30px;border-radius:15px;-ms-flex-preferred-size:auto!important}#loginContainer #submit{padding-left:40px;padding-right:40px}.login-background{min-height:85vh;padding:10px 0 30px;background-image:url(" + require("../../styles/img/login_bg_1024.jpg") + ");background-repeat:no-repeat;background-size:cover}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/containers/login/login.styl
// module id = 95
// module chunks = 1